import { render, staticRenderFns } from "./OrderPaymentTile.vue?vue&type=template&id=7c2f9fa7&"
import script from "./OrderPaymentTile.vue?vue&type=script&lang=ts&"
export * from "./OrderPaymentTile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports